import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import CampaignModel from 'cio/models/campaign';
import Route from 'cio/routes/base';
import FeaturesService from 'ember-feature-flags/services/features';
import IndexController from './controller';
import ConfirmChangesService from 'cio/services/confirm-changes';
import MessageSettingsService from 'cio/services/message-settings';

export default class IndexRoute extends Route {
  @service features!: FeaturesService;
  @service confirmChanges!: ConfirmChangesService;
  @service messageSettings!: MessageSettingsService;

  templateName = 'base/setup/settings/index';

  afterModel() {
    return this.messageSettings.loadMessagingLimit.perform();
  }

  setupController(controller: IndexController, model: CampaignModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.setProperties({
      originalSendToUnsubscribed: model.sendToUnsubscribed,
      originalSubscriptionTopicId: model.subscriptionTopicId,
    });
    this.confirmChanges.register(controller, this);
  }
}
